import CoordinatorExternalEducationTemplateListContainer from '@src/components/externaleducation/CoordinatorExternalEducationTemplateListContainer';
import React from 'react';

const ExternalEducationTemplateListPage = () => <CoordinatorExternalEducationTemplateListContainer />;

export default ExternalEducationTemplateListPage;
